import create from 'zustand';

interface StatusMessage {
  icon: string;
  main_text: string;
  sub_text?: string;
  cta_details?: Array<{
    text: string;
    action: string;
    highlight?: number;
    link?: string;
  }>;
  close_icon?: boolean;
}

interface HeaderExtensionStore {
  headerExtension: StatusMessage | null;
  wsOverrideActive: boolean;
  setHeaderExtension: (statusMessage: StatusMessage) => void;
  clearHeaderExtension: () => void;
}

export const useHeaderExtensionStore = create<HeaderExtensionStore>(set => ({
  headerExtension: null,
  wsOverrideActive: false,

  setHeaderExtension: statusMessage =>
    set({headerExtension: statusMessage, wsOverrideActive: true}),

  clearHeaderExtension: () =>
    set({headerExtension: null, wsOverrideActive: true}),
}));
